module.exports = __webpack_public_path__ + "static/googleplay-e53a269c4a41cb0f6bc6ddf9524f4ad1.png";